import React, { useEffect } from "react";
import { Navigate, Route, Routes, useLocation, useNavigate } from "react-router-dom";
import { beginLogin, loadTokens, readClaimsFromIdToken, clearTokens, tokenValid, refreshAccessToken } from "./auth";
import { ReportListPage } from "./pages/ReportListPage";
import { ReportDetailPage } from "./pages/ReportDetailPage";
import { OAuthCallbackPage } from "./pages/OAuthCallbackPage";

export function App(): React.JSX.Element {
  return (
    <div className="app-shell">
      <Routes>
        <Route path="/oauth/callback" element={<OAuthCallbackPage />} />
        <Route path="/" element={<Protected><Shell><ReportListPage /></Shell></Protected>} />
        <Route path="/r/:contactId" element={<Protected><Shell><ReportDetailPage /></Shell></Protected>} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </div>
  );
}

function Protected({ children }: { children: React.ReactNode }): React.JSX.Element {
  const location = useLocation();
  const [ready, setReady] = React.useState(false);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const existing = loadTokens();
      if (tokenValid(existing)) {
        setReady(true);
        return;
      }
      const refreshed = await refreshAccessToken();
      if (cancelled) return;
      if (refreshed) {
        setReady(true);
      } else {
        void beginLogin(location.pathname + location.search);
      }
    })();
    return () => { cancelled = true; };
  }, [location.pathname, location.search]);

  if (!ready) return <div className="loading">Signing you in&hellip;</div>;
  return <>{children}</>;
}

function Shell({ children }: { children: React.ReactNode }): React.JSX.Element {
  const claims = readClaimsFromIdToken();
  const nav = useNavigate();
  const signOut = (): void => {
    clearTokens();
    nav("/");
  };
  return (
    <>
      <header className="brand-band">
        <div>
          <h1>TradeBid</h1>
          <div className="subtitle">Dealer Meeting Reports</div>
        </div>
        {claims && (
          <div className="user-badge">
            {claims.givenName ?? claims.email ?? claims.sub}
            <button onClick={signOut}>Sign out</button>
          </div>
        )}
      </header>
      <main className="container">{children}</main>
      <footer className="footer">Otto Voice · {new Date().getFullYear()}</footer>
    </>
  );
}
